import React from 'react';
import Chart from 'react-apexcharts';

// Professional color palette
const COLORS = [
  "#2196F3", // Primary blue
  "#4CAF50", // Success green
  "#FFC107", // Warning amber
  "#F44336", // Error red
  "#9C27B0", // Purple
  "#00BCD4", // Cyan
  "#FF9800", // Orange
  "#607D8B", // Blue grey
];

const PieGraph = ({ data = [] }) => {
  const options = React.useMemo(() => {
    // Safely calculate total and percentages
    const total = data.reduce((sum, item) => sum + (item.value || 0), 0);
    
    const series = data.map(item => item.value || 0);
    const labels = data.map(item => item.name || 'Unknown');
    
    return {
      chart: {
        type: 'pie',
        background: 'transparent',
        toolbar: {
          show: false
        }
      },
      colors: COLORS,
      labels: labels,
      series: series,
      dataLabels: {
        enabled: true,
        formatter: function (val, opts) {
          if (total === 0) return '0%';
          const value = opts.w.globals.series[opts.seriesIndex];
          return `${((value / total) * 100).toFixed(1)}%`;
        },
        style: {
          fontSize: '12px',
          fontFamily: 'Inter, sans-serif',
          fontWeight: 600,
          colors: ['#fff']
        },
        dropShadow: {
          enabled: true,
          blur: 3,
        }
      },
      plotOptions: {
        pie: {
          startAngle: 0,
          endAngle: 360,
          expandOnClick: true,
          offsetX: 0,
          offsetY: 0,
          customScale: 1,
          dataLabels: {
            offset: 0,
            minAngleToShowLabel: 10
          },
        }
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['#fff']
      },
      legend: {
        show: true,
        position: 'bottom',
        horizontalAlign: 'center',
        floating: false,
        fontSize: '12px',
        fontFamily: 'Inter, sans-serif',
        fontWeight: 400,
        formatter: function(seriesName, opts) {
          if (total === 0) return seriesName;
          const value = opts.w.globals.series[opts.seriesIndex];
          const percentage = ((value / total) * 100).toFixed(1);
          return `${seriesName} - ${value} (${percentage}%)`;
        },
        markers: {
          width: 8,
          height: 8,
          strokeWidth: 0,
          strokeColor: '#fff',
          radius: 12,
          offsetX: 0,
          offsetY: 0
        },
        itemMargin: {
          horizontal: 10,
          vertical: 5
        }
      },
      tooltip: {
        enabled: true,
        theme: 'light',
        style: {
          fontSize: '12px',
          fontFamily: 'Inter, sans-serif'
        },
        y: {
          formatter: function(value) {
            if (total === 0) return '0%';
            return `${value} (${((value / total) * 100).toFixed(1)}%)`;
          }
        }
      },
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 280
          },
          legend: {
            position: 'bottom'
          }
        }
      }]
    };
  }, [data]);

  return (
    <div style={{ width: '100%', height: '300px', maxHeight: '100%' }}>
      <Chart
        options={options}
        series={options.series}
        type="pie"
        height="100%"
        width="100%"
      />
    </div>
  );
};

export default PieGraph;
